import React, { useEffect, useState } from "react"
import { IReplenishmentDto } from "../../../../types/replenishment/IReplenishmentDto"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { IPageResponse } from "../../../../types/IPageResponse"
import { IClientRequestDto } from "../../../../types/request/IClientRequestDto"
import { ModalPopUp } from "../../../common/element/ModalPopUp"
import { IModalMessage } from "../../../../types/error/IModalMessage"
import { getFieldError, round2Digits, spacedNum } from "../../../common/CommonHelper"
import { IErrorModel } from "../../../../types/error/IErrorModel"
import { REPLENISHMENT_ROUTE, REQUEST_ROUTE } from "@/routes"
import { Link, useNavigate } from "react-router-dom"
import Button from "@/ui/components/Button"

export const BasisTab: React.FC<{
  replenishment: IReplenishmentDto
  setReplenishment: (r: IReplenishmentDto) => void
  errorModel: IErrorModel | undefined
  sending: boolean
  submit: () => void
}> = ({ replenishment, setReplenishment, errorModel, sending, submit }) => {
  const navigate = useNavigate()

  const [requestList, setRequestList] = useState<IPageResponse<IClientRequestDto>>()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)

  const doSubmit = () => {
    if (sending) return
    if (!replenishment?.clientRequestId) {
      setModalMessage({
        ...modalMessage,
        title: "Ошибка!",
        text: "Создайте пополнение на основании запроса, если запроса нет, создайте запрос"
      })
    } else {
      submit()
    }
  }

  useEffect(() => {
    TrinityAPI.getClientRequests(0, "APPROVED", "", response => {
      if (response.status === 200) {
        setRequestList(response.data)
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка загрузки запросов: " + response.data.message })
      }
    })
  }, [])

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <div className="container">
        <div className="container-pop-up">
          <ul className="form-left">
            <li className="form-block-popup">
              <h4 className="heading-chapter">Создание запроса</h4>
              {!replenishment.id && (
                <p className="message-course-yes">
                  Внимание! Создать пополнение можно только на основании одобренного менеджером запроса. Если Вы еще не
                  создали запрос, вы можете сделать это по ссылке ниже{" "}
                  <Link className="small-button-white" to={REQUEST_ROUTE}>
                    здесь
                  </Link>
                </p>
              )}
              {replenishment.stage !== "BASIS" ? (
                <fieldset>
                  <legend>На основании запроса</legend>
                  <p className="text-form">№{replenishment.clientRequestId}</p>
                </fieldset>
              ) : (
                <fieldset>
                  <legend>На основании запроса</legend>
                  <select
                    className="input-form"
                    onChange={e =>
                      setReplenishment({
                        ...replenishment,
                        clientRequestId: e.target.value
                      })
                    }
                    value={replenishment.clientRequestId}
                    disabled={replenishment.stage !== "BASIS"}
                  >
                    <option value="">Выберите запрос</option>
                    {requestList?.items
                      .filter(i => i.status !== "USED")
                      .map((item, i) => (
                        <option key={i} value={item.id}>
                          №{item.id} ({spacedNum(round2Digits(Number(item.invoicePrice) / 100))} {item.currency},{" "}
                          {item.recipientCountry?.name})
                        </option>
                      ))}
                  </select>
                </fieldset>
              )}
              {getFieldError(errorModel, "clientRequestId") && (
                <p className="error-form">{getFieldError(errorModel, "clientRequestId")}</p>
              )}
            </li>
            {!replenishment.id && (
              <div className="flex-row-10 flex-wrap-mobile">
                <Button onClick={doSubmit} loading={sending}>
                  Создать
                </Button>
                <Button variant="grey" onClick={() => navigate(REPLENISHMENT_ROUTE)}>
                  Отмена
                </Button>
              </div>
            )}
          </ul>
        </div>
      </div>
    </>
  )
}
